import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalToBodyDirective } from 'src/app/directives/portal-to-body.directive';

@Component({
  selector: 'app-image-preview',
  standalone: true,
  imports: [CommonModule, PortalToBodyDirective],
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.css']
})
export class ImagePreviewComponent {
  @Input() alt: string = 'Vista previa';
  previewImage: string | null = null;

  openModal(imgUrl: string) {
    this.previewImage = imgUrl;
    const modal = new (window as any).bootstrap.Modal(
      document.getElementById('imagePreviewModal'),
      {}
    );
    modal.show();
  }
}